<ng-container *ngIf="results.length">
	<h2>Vehicle Results ({{results.length}})</h2>
	<p-table #dt [value]="results" [columns]="cols" [rows]="10" [paginator]="true" styleClass="mvd_table--notfixed">
		<ng-template pTemplate="caption">
			<div class="row">
				<div class="col-sm-6 col-md-3">
					<input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..." (input)="dt.filterGlobal($event.target.value, 'contains')">
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header" let-columns>
			<tr>
				<th *ngFor="let col of columns" [pSortableColumn]="col.field">
					{{col.header}}
					<p-sortIcon [field]="col.field"></p-sortIcon>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-result>
			<tr>
				<td><a href="javascript:void(0)" title="View Vehicle" (click)="select(result)">{{result.vehicleId}}</a></td>
                <td>{{result.vehicleType}} {{result.vehicleTypeDisplayValue}}</td>
                <td>{{result.bodyStyle}}{{result.bodyStyleTypeDisplayValue}}</td>
				<td>{{result.vin}}</td>
                <td>{{result.year}} {{result.modelYear}}</td>
                <td>{{result.make}} {{result.makeDisplayValue}}</td>
                <td>{{result.model}} {{result.modelDisplayValue}}</td>
				<td>{{result.plateNumber}}</td>
				<td>{{result.registrationEndDate | serverTime}}</td>
			</tr>
		</ng-template>
	</p-table>
</ng-container>